import React from "react";
import { LOGO_DARK_BASE64, LOGO_LIGHT_BASE64 } from "~/assets/logoBase64";

export const AppLogo: React.FC = () => {
  return (
    <>
      <img
        src={LOGO_LIGHT_BASE64}
        alt="Sky Logo"
        className="h-8 w-auto transition-all duration-300 dark:hidden"
      />
      <img
        src={LOGO_DARK_BASE64}
        alt="Sky Logo"
        className="h-8 w-auto transition-all duration-300 hidden dark:block"
      />
    </>
  );
};
